/** Précision avec format reverse date (ex: yyyyMMddhhmm => 12). */
export enum EUTCAccuracy {
	day = 8,
	minutes = 12,
	hours = 10,
	milliseconds = 17,
	seconds = 14
}
